import { EventEmitter, Injectable, Output } from '@angular/core';
import { AssignmentRuleFilters } from './assignmentRuleFilters';

@Injectable()
export class AssignmentRulesComunicationService {

  @Output() readonly filter: EventEmitter<AssignmentRuleFilters> = new EventEmitter();
  @Output() readonly reloadTable: EventEmitter<any> = new EventEmitter();

  applyFilter(filter: AssignmentRuleFilters): void {
    this.filter.emit(filter);
  }

  reload(): void {
    this.reloadTable.emit();
  }

}
